<template>
  <div class="px-1 text-xs sm:text-sm mt-2">
    <div class="flex justify-between items-start">
      <div :class="isDomain ?'text-text_color':'text-black'">
        <div class="font-bold break-words px-0.5 flex-shrink-1">
          {{ material.name }}
        </div>
        <div v-if="!isDomain" class="text-opacity-90 text-[10px] sm:text-xs">
          {{ material.store?.name }}
        </div>
        <div v-if="storeMaterial?.price_visible" class="flex">
          <div :dir="material.currencyIsRtl ? 'rtl' : 'ltr'" class="font-bold">
            <span v-if="material.discountPrice">
              {{ material.discountPrice }}
            </span>
            <span v-else class="mx-1">{{ material.stringPrice }}</span>
          </div>
          <div
            v-if="material.discountPrice"
            :dir="material.currencyIsRtl ? 'rtl' : 'ltr'"
          >
            <small class="line-through text-opacity-90 mx-1">
              {{ material.stringPrice }}
            </small>
          </div>
        </div>
      </div>
      <div>
        <v-icon
          v-if="storeMaterial?.price_visible && storeMaterial?.cart_visible"
          icon=" mdi mdi-cart-plus"
          class="rtl:-ml-1 ltr:-mr-1 custom-size-shopping-cart-domain"
          @click.stop="emit('toggleClickCart')"
        />
        <IconsCartWhatsapp
          v-else-if="!storeMaterial?.cart_visible"
          class="rtl:-ml-2 ltr:-mr-2 w-8 h-8"
          @click.stop="emit('toggleClickCart')"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Material } from '~~/composables/useMenuModel'
const props = withDefaults(
  defineProps<{
    material: Material
  }>(),
  {}
)
const emit = defineEmits(['toggleClickCart'])
const isDomain = useIsDomain()
const { store } = useDomainState()

const storeMaterial = computed(() => {
  return isDomain ? store.value : props.material.store
})
</script>
<style scoped>
.v-icon--size-default.custom-size-shopping-cart-domain {
  @apply text-[24px]  sm:text-[28px]  !important;
}
</style>
